import {showSuccessMessage} from '@/helper';

export default {
    save(data) {
        return new Promise((resolve, reject) => {
            http.post('api/interaction-forms', data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    changeState(interactionFormID, state, additionalFormIds = undefined) {
        return new Promise((resolve, reject) => {
            http.post(`api/interaction-forms/${interactionFormID}/change-state`, {state, additional_form_ids: additionalFormIds}).then(response => {
                resolve(response.data);
                showSuccessMessage(response.data.message);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getAllByClient(clientId) {
        return new Promise((resolve, reject) => {
            http.get(`api/clients/${clientId}/interaction-forms/list`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    continueOnboarding(interactionFormID) {
        return new Promise((resolve, reject) => {
            http.get(`api/interaction-forms/${interactionFormID}/continue`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    evaluateAmlStepPreview(interactionFormID, data) {
        return new Promise((resolve, reject) => {
            http.post(`api/interaction-forms/${interactionFormID}/steps/aml/evaluate-preview`, {data}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
    },
    getDocuments(interactionFormID) {
        return new Promise((resolve, reject) => {
            http.get(`api/interaction-forms/${interactionFormID}/documents`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    delete(interactionFormID) {
        return new Promise((resolve, reject) => {
            http.delete(`api/interaction-forms/${interactionFormID}/`).then(response => {
                showSuccessMessage(response.data.message);
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
}
